/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MenuProfileAliases {
  AVATAR_PRINCIPAL = 'avatar-principal',
  CARD_AVATAR_PRINCIPAL = 'card-avatar-principal',
  CONTEXTUAL_BAR_PRINCIAL = 'contextual-bar-princial',
  DECK_PRINCIPAL = 'deck-principal',
  LAYOUT_CHANGE_USER = 'layout-change-user',
  PANEL_0 = 'panel-0',
  PANEL_GENERAL = 'panel-general',
}
export { MenuProfileAliases };
